// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ICustomPageReceiptDocumentFileResponse,
} from '../models/index';
import {
    ICustomPageReceiptDocumentFileResponseFromJSON,
    ICustomPageReceiptDocumentFileResponseToJSON,
} from '../models/index';

export interface SearchReceiptFilesRequest {
    employeeId?: number;
    searchValue?: string;
    available?: boolean;
    size?: number;
    page?: number;
}

/**
 * ReceiptControllerApi - interface
 * 
 * @export
 * @interface ReceiptControllerApiInterface
 */
export interface ReceiptControllerApiInterface {
    /**
     * 
     * @param {number} [employeeId] 
     * @param {string} [searchValue] 
     * @param {boolean} [available] 
     * @param {number} [size] 
     * @param {number} [page] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceiptControllerApiInterface
     */
    searchReceiptFilesRaw(requestParameters: SearchReceiptFilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICustomPageReceiptDocumentFileResponse>>;

    /**
     */
    searchReceiptFiles(requestParameters: SearchReceiptFilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICustomPageReceiptDocumentFileResponse>;

}

/**
 * 
 */
export class ReceiptControllerApi extends runtime.BaseAPI implements ReceiptControllerApiInterface {

    /**
     */
    async searchReceiptFilesRaw(requestParameters: SearchReceiptFilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICustomPageReceiptDocumentFileResponse>> {
        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['available'] != null) {
            queryParameters['available'] = requestParameters['available'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/documents/receipts/files`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICustomPageReceiptDocumentFileResponseFromJSON(jsonValue));
    }

    /**
     */
    async searchReceiptFiles(requestParameters: SearchReceiptFilesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICustomPageReceiptDocumentFileResponse> {
        const response = await this.searchReceiptFilesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
